export const NEW_WINDOW_LINK = 'js-open-link-in-new-window';
